import { useApp } from "../Components/Provider";


export const useStore = () => {
    const viewApp = useApp();
    return viewApp.store;
};
